import Icons from "assets/Icons";
import OnlyPromoter from 'components/guards/OnlyPromoter';
import React from "react";

interface IEventDateProps {

  id: string;
  timezoneOffset: number | string;
  hostName: string | null;
  location: string;
  currency: string;
  creationTimeZone?: string;
  timeInfo?: any;
  revenueTotal?: any;
  isHostOrAdmin?: boolean;
  totalPrivate?: any;
  totalPublic?: any

}
export default (props: IEventDateProps) => {
  const { hostName, location, timeInfo } = props;
  return (
    <div style={{ fontSize: '15px', color: '#878399' }}>
      <div style={{ width: '100%' }}>
        <div style={{ float: 'left', width: '10%' }}>
          <img src={Icons.place} alt="Where is event happening?" />
        </div>

        <div className="cut-text" style={{ float: 'right', width: '90%', paddingTop: '5px', paddingLeft: '5px' }}>
          {location}
        </div>
        <p />
      </div>
      <p><br /></p>
      {hostName === null ? "" :
        <div style={{ width: '100%' }}>
          <div style={{ float: 'left', width: '10%' }}>
            <img src={Icons.userDark} alt="Who is event host?" />
          </div>
          <div className="cut-text" style={{ float: 'right', width: '90%', paddingTop: '5px', paddingLeft: '5px' }}>
            {hostName}
          </div>
          <p><br /></p>
        </div>
      }
      <React.Fragment>
        <div style={{ width: '100%' }}>
          <div style={{ float: 'left', width: '10%' }}>
            <img
              src={Icons.materialCalendar}
              alt="When is Event happening?"
            />
          </div>
          <div className="cut-text" style={{ float: 'right', width: '90%', paddingTop: '5px', paddingLeft: '5px' }}>
            {
              String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
              String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
            }
            {timeInfo.startAMPM ? 'PM' : 'AM'}
          </div>
        </div>
        <OnlyPromoter eventId={props.id}>
          <p><br /></p>
          <div style={{ width: '100%' }}>
            {
              props.isHostOrAdmin ?
                <div style={{ width: '50%', float: 'left' }}>
                  <div style={{ float: 'left', width: screen.width > 768 ? '20%' : '25%', paddingRight: '5px', paddingTop: '3px' }}>
                    <img src={Icons.newTicket} alt="Your Revenue" />
                  </div>
                  <div className="cut-text sexyBlack" style={{ float: 'right', width: screen.width > 768 ? '80%' : '75%', paddingTop: screen.width > 768 ? '6px' : '9px', paddingLeft: '5px' }}>
                    {(Number(props.totalPrivate) + Number(props.totalPublic)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                  </div>
                  <p />
                </div>
                :
                <div style={{ width: '50%', float: 'left' }}>
                  <div style={{ float: 'left', width: screen.width > 768 ? '20%' : '25%', paddingRight: '5px', paddingTop: '3px' }}>
                    <img src={Icons.newTicket} alt="Tickets Sold" />
                  </div>
                  <div className="cut-text sexyBlack" style={{ float: 'right', width: screen.width > 768 ? '80%' : '75%', paddingTop: screen.width > 768 ? '6px' : '9px', paddingLeft: '5px' }}>
                    {(Number(props.totalPrivate)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                  </div>
                  <p />
                </div>
            }
            <div style={{ width: '50%', float: 'right', paddingTop: screen.width > 768 ? '3px' : '6px' }}>
              <div style={{ float: 'left', width: '20%' }}>
                <img src={props.currency === 'INR' ? Icons.rupee : Icons.dollar} alt="Your Revenue" style={props.currency === 'INR' ? { maxWidth: '15px', paddingTop: '3px' } : {}} />
              </div>
              <div className="cut-text sexyBlack" style={{ float: 'right', width: '80%', paddingTop: '3px', paddingLeft: '5px' }}>
                {
                  Number(props.revenueTotal) % 1 === 0 ?
                    (Number(props.revenueTotal) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    : (Number(props.revenueTotal) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                }
              </div>
              <p />
            </div>
          </div>
        </OnlyPromoter>
        <p />
      </React.Fragment>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/platform/card/modules/EventDetailBar/EventDetailBar.tsx